import { TweenMax, Power1 } from 'gsap'
import EventBus from './../../../event-bus'

const PAGE_GAP = 10

class ContentManager {
  constructor (pageCarousel) {
    this.pageCarousel = pageCarousel
  }
  init (componentList, eventPrefix) {
    this.componentList = componentList
    this.eventPrefix = eventPrefix
    this.data = {
      pageHeight: window.innerHeight,
      carouselMode: false,
      carouselModeDelayed: false,
      introGuideComponent: null,
      activeIndex: 0,
      guideMode: false
    }
    this._indexOffset = 0
    this._pageOffset = 0
    this.updatePageWidth(true)
  }
  setActiveIndex (index) {
    this.data.activeIndex = index
    EventBus.dispatchEvent(this.eventPrefix + '.CHANGE', {
      index: index,
      range: 3
    })
    return index
  }
  setIndex (index, duration = 0.5) {
    TweenMax.to(this, duration, { _pageOffset: 0, _indexOffset: index * (window.innerWidth + PAGE_GAP), ease: Power1.easeInOut, onUpdate: this._updatePageX })
  }
  resetOffsetIndex () {
    this._indexOffset = this.data.activeIndex * (window.innerWidth + PAGE_GAP)
  }
  updatePageWidth (init) {
    this._pageWidth = window.innerWidth
    this._updatePageX(init)
  }
  updatePageOffset (o) {
    this._pageOffset = o
    this._updatePageX()
  }
  initGuide (component) {
    this.data.introGuideComponent = component
  }
  removeGuide () {
    this.data.introGuideComponent = null
  }
  _updatePageX = (init) => {
    let cm = this
    for (let i = 0; i < this.componentList.length; i++) {
      cm.data['page' + i + '_x'] = ((cm._pageWidth + PAGE_GAP) * i) + cm._pageOffset + cm._indexOffset
      if (init) {
        cm.data['page' + i + '_y'] = 0
      }
    }
  }
  changeContent = (vm, navItem, skipAnim) => {
    if (navItem.index !== -this.pageCarousel.selectedIndex) {
      let delay = this.data.carouselMode ? 0 : 150
      let vm = this
      this.pageCarousel.enterCarouselMode()
      clearTimeout(this.changeContentTimeout1)
      clearTimeout(this.changeContentTimeout2)

      let di = -this.pageCarousel.selectedIndex - navItem.index
      if (di < 0) di = -di
      let duration = di * 0.4
      if (duration > 3) duration = 3
      this.changeContentTimeout1 = setTimeout(function () {
        vm.pageCarousel.setSelectedIndex(-navItem.index, duration)
      }, delay)
      this.changeContentTimeout2 = setTimeout(function () {
        vm.pageCarousel.exitCarouselMode()
      }, delay + (duration * 1000))
    }
  }
  updatePageHeight = (vm) => {
    let p = vm.$refs['page' + -this.pageCarousel.selectedIndex]
    if (p) {
      this.data.pageHeight = p.clientHeight
    }
  }
  destroy () {
    this.data.carouselMode = false
    this.data.carouselModeDelayed = false
    clearTimeout(this.changeContentTimeout1)
    clearTimeout(this.changeContentTimeout2)
  }
}

export default ContentManager
